<template>
    <div>
        <PageHeader type="Your collection" title="Liked Songs">
            <template #art>
                <div class="flex h-44 w-44 items-center justify-center rounded-lg bg-gradient-to-br from-nomad-accent to-nomad-800 shadow-lift sm:h-48 sm:w-48 lg:h-56 lg:w-56">
                    <span class="icon-heart text-6xl text-black" aria-hidden="true"></span>
                </div>
            </template>
            <template #meta>Only for you<template v-if="total"> · {{ total }} {{ total === 1 ? 'song' : 'songs' }}</template></template>
        </PageHeader>

        <!-- Needs a tap: browsers only open sign-in popups from one -->
        <div v-if="status === 'connect'" class="mx-auto max-w-md py-12 text-center">
            <h2 class="text-xl font-bold text-white">See your liked songs</h2>
            <p class="mt-2 text-nomad-300">Confirm your Google account once to bring in the songs you've liked, here and in the app.</p>
            <button type="button" class="nl-btn-primary mt-6" @click="connectFavorites">Continue with Google</button>
        </div>

        <div v-else-if="status === 'error'" class="py-12 text-center">
            <p class="text-nomad-300">Couldn't load your liked songs.</p>
            <button type="button" class="nl-btn-ghost mt-4" @click="loadFavorites()">Try again</button>
        </div>

        <div v-else-if="status === 'ready' && !favorites.length" class="py-12 text-center text-nomad-300">
            Tap the heart on any song to save it here.
        </div>

        <template v-else-if="status === 'ready'">
            <div class="mb-4 flex items-center gap-3">
                <div class="relative min-w-0 flex-1 sm:max-w-sm">
                    <span class="icon-search absolute left-3 top-1/2 -translate-y-1/2 text-nomad-400" aria-hidden="true"></span>
                    <input v-model.trim="query" type="search" placeholder="Search liked songs" aria-label="Search liked songs"
                        class="w-full rounded-full border-0 bg-white/[0.06] py-2 pl-10 pr-4 text-sm text-white placeholder:text-nomad-400 focus:ring-1 focus:ring-nomad-accent" />
                </div>
                <button type="button" class="nl-btn-ghost shrink-0" :aria-pressed="sorted" @click="sorted = !sorted">
                    {{ sorted ? 'A–Z' : 'Sort' }}
                </button>
            </div>

            <p v-if="!visible.length" class="py-10 text-center text-nomad-300">No liked songs match your search.</p>
            <TrackList v-else :songs="visible" header likes />

            <div v-if="hasMore" class="mt-6 text-center">
                <button type="button" class="nl-btn-ghost" :disabled="loadingMore" @click="loadFavorites(page + 1)">
                    {{ loadingMore ? 'Loading liked songs…' : 'Show more' }}
                </button>
            </div>
            <p v-else class="mt-6 text-center text-xs text-nomad-500">Tap a heart to remove a favorite.</p>
        </template>

        <div v-else class="py-16 text-center text-nomad-400" role="status">Loading liked songs…</div>
    </div>
</template>
<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
import { mapActions, mapGetters, mapState } from "vuex";

const nameOf = (song) => song.title || song.name || "";

export default {
    components: { PageHeader, TrackList },
    data() {
        return { query: "", sorted: false };
    },
    computed: {
        ...mapState("favorites", {
            favorites: "all",
            status: "status",
            total: "total",
            page: "page",
            loadingMore: "loadingMore",
        }),
        ...mapGetters("favorites", ["hasMore"]),
        visible() {
            const query = this.query.toLowerCase();
            const songs = this.favorites.filter(
                (song) =>
                    nameOf(song).toLowerCase().includes(query) ||
                    (song.artist?.name || "").toLowerCase().includes(query),
            );
            return this.sorted ? [...songs].sort((a, b) => nameOf(a).localeCompare(nameOf(b))) : songs;
        },
    },
    methods: mapActions("favorites", ["loadFavorites", "connectFavorites"]),
    mounted() {
        this.loadFavorites();
    },
    beforeMount() {
        document.title = "Liked Songs";
    },
};
</script>
